
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const navigate = useNavigate();

  const faqs = [
    {
      question: '商品代は本当にかかりませんか？',
      answer: 'はい。対象案件は購入前に全額提供します。'
    },
    {
      question: '初心者でもできますか？',
      answer: 'はい。テンプレ＆見本をご用意。専任スタッフが添削します。'
    },
    {
      question: '謝礼の支払いは？',
      answer: '初回モニター案件の依頼時は、事前に費用を銀行振込します。2回目以降は、振込手数料削減のために、月末締め、翌月初め5営業日以内に銀行振込します。'
    },
    {
      question: '月にどのくらい稼げますか？',
      answer: 'はい。活動実績により変動しますが、月2-3件で5,000円〜、月10件以上で20,000円〜が目安です。'
    },
    {
      question: 'レビューの投稿に期限はありますか？',
      answer: 'はい。商品到着から2週間以内の投稿をお願いしています。使用期間が必要な商品は個別調整いたします。'
    },
    {
      question: '個人情報の取り扱いは安全ですか？',
      answer: 'はい。個人情報保護法に基づき厳重管理し、商品発送とお支払い等当サービスの運営・管理のためのみに使用いたします。'
    },
    {
      question: '商品を返却する必要はありますか？',
      answer: 'モニターの仕事が完了すれば、返却不要です。モニター終了後、商品は無料でお持ちいただけます。なお、商品は返却、転売は禁止です。'
    },
    {
      question: 'モニター活動を辞めたい場合は？',
      answer: 'はい。依頼しているモニター案件が残っていなければ、いつでも退会可能です。ホームページから連絡頂ければ、退会できます。違約金等は一切発生しません。'
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const scrollToApplication = () => {
    navigate('/monitor');
  };

  return (
    <section id="faq" className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            よくある質問
          </h2>
          <p className="text-xl text-gray-600">
            商品モニターについてのご質問にお答えします
          </p>
        </div>
        
        <div className="space-y-4 mb-12">
          {faqs.map((faq, index) => (
            <div key={index} className="border border-gray-200 rounded-lg overflow-hidden">
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-6 py-4 text-left bg-gray-50 hover:bg-gray-100 transition-colors flex justify-between items-center cursor-pointer"
              >
                <span className="font-semibold text-gray-900 pr-4">
                  {faq.question}
                </span>
                <i className={`ri-arrow-${openIndex === index ? 'up' : 'down'}-s-line text-xl text-gray-600 flex-shrink-0`}></i>
              </button>
              {openIndex === index && (
                <div className="px-6 py-4 bg-white">
                  <p className="text-gray-700 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* FAQ直後のCTA */}
        <div className="text-center bg-blue-50 rounded-2xl p-8 mb-12">
          <h3 className="text-2xl font-bold text-gray-900 mb-4">
            疑問が解決したら、今すぐ始めましょう！
          </h3>
          <p className="text-gray-600 mb-6">
            商品モニターで新しい収入源を手に入れませんか？
          </p>
          <button
            onClick={() => window.REACT_APP_NAVIGATE('/go-form')}
            className="bg-teal-600 text-white px-8 py-3 rounded-lg hover:bg-teal-700 transition-colors flex items-center whitespace-nowrap cursor-pointer"
          >
            <i className="ri-gift-line mr-2"></i>
            商品モニター会員応募
          </button>
        </div>
        
        <div className="text-center bg-blue-50 rounded-2xl p-8">
          <h3 className="text-xl font-semibold text-gray-900 mb-4">
            その他のご質問がございましたら
          </h3>
          <p className="text-gray-600 mb-6">
            お気軽にお問い合わせください。専門スタッフが丁寧にお答えいたします。
          </p>
          <div className="inline-flex items-center bg-blue-600 text-white px-6 py-3 rounded-lg cursor-pointer hover:bg-blue-700 transition-colors">
            <i className="ri-customer-service-line mr-2"></i>
            お問い合わせする
          </div>
        </div>
      </div>
    </section>
  );
}
